import React from 'react';

import EnvelopeIcon from 'assets/envelope.svg';
import Button from 'components/common/Button';
import DeleteIcon from 'assets/delete.svg';

const TicketingInfoRowCard = (props) => {
  return (
    <div className="flex flex-wrap w-full items-center text-lg rounded-md border border-gray-300 px-4 py-4 my-8">
      <div className="w-1/12">
        <img width="30" height="30" src={EnvelopeIcon} alt="Email" />
      </div>
      <div className="w-8/12 text-left">{`${props.name}`}</div>
      <div className="w-1/12">
        <div class="relative inline-block w-10 ml-4 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="toggle"
            id="toggle"
            //   checked={true}
            class="focus:outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label
            for="toggle"
            class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
          ></label>
        </div>
      </div>
      <div className="w-1/12">
        <Button
          intent="success"
          // showSpinner={true}
          type="button"
          extendClass="text-md"
          // onClick={() => {
          //   setState((draft) => {
          //     draft.toggleAddProvider = true;
          //   });
          // }}
          // loading={sendUserInviteTeamState.loading ? true : false}
          //   disable={userLoginState.loading ? false : isSubmitting}
        >
          Send Test
        </Button>
      </div>
      <div className="w-1/12">
        <div
          title="Delete"
          className="bg-red-500 px-2 py-2 w-10 h-10 rounded-md cursor-pointer  "
        >
          <img className="w-full h-full" src={DeleteIcon} />
        </div>
      </div>
    </div>
  );
};

export default TicketingInfoRowCard;
